import {getFighterLevel} from '../../../shared/rules/fighter.mjs';
export const TACTICAL_MIND_CHECK_EVENT='realmtracker:tactical-mind-check';
export function publishTacticalMindCheck({character,context,source,total,d20s}){
 if(getFighterLevel(character)<2||!['skill-check','ability-check','tool-check'].includes(context))return;
 const detail={id:window.crypto?.randomUUID?.()||`check-${Date.now()}-${Math.random()}`,actorId:String(character.characterId||character._id||''),campaignId:character.campaign,context,label:source||'Ability check',total,d20s};
 if(detail.actorId)window.dispatchEvent(new CustomEvent(TACTICAL_MIND_CHECK_EVENT,{detail}));
}
